import { render, staticRenderFns } from "./industryRow.vue?vue&type=template&id=160fa929&"
import script from "./industryRow.vue?vue&type=script&lang=ts&"
export * from "./industryRow.vue?vue&type=script&lang=ts&"
import style0 from "./industryRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports